import { IconProps } from '@/assets/types/icon'

const TikTokLogo = ({ className, ...props }: IconProps) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M16.0364 0H15.9636C7.14713 0 0 7.14713 0 15.9636V16.0364C0 24.8529 7.14713 32 15.9636 32H16.0364C24.8529 32 32 24.8529 32 16.0364V15.9636C32 7.14713 24.8529 0 16.0364 0Z"
        fill="#7D7D7D"
      />
      <path
        d="M23.7351 11.5767V14.5981C23.2071 14.5465 22.5209 14.4266 21.7619 14.1485C20.7709 13.7853 20.0332 13.2886 19.55 12.9041V19.0108L19.5377 18.9918C19.5455 19.1128 19.55 19.2362 19.55 19.3606C19.55 22.3932 17.0824 24.8619 14.0487 24.8619C11.0149 24.8619 8.54736 22.3932 8.54736 19.3606C8.54736 16.328 11.0149 13.8582 14.0487 13.8582C14.3458 13.8582 14.6373 13.8817 14.922 13.9277V16.9054C14.6485 16.8078 14.3547 16.7551 14.0487 16.7551C12.6125 16.7551 11.4432 17.9233 11.4432 19.3606C11.4432 20.7979 12.6125 21.9661 14.0487 21.9661C15.4848 21.9661 16.6541 20.7968 16.6541 19.3606C16.6541 19.3068 16.653 19.253 16.6497 19.1992V7.33215H19.6688C19.68 7.58777 19.6901 7.84563 19.7013 8.10124C19.7215 8.60462 19.9009 9.08782 20.2137 9.48357C20.5803 9.94884 21.1218 10.4892 21.8819 10.9208C22.5938 11.3233 23.262 11.4971 23.7351 11.5789V11.5767Z"
        fill="white"
      />
    </svg>
  )
}

export default TikTokLogo
